/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import Button from '@atlaskit/button/custom-theme-button';
import { gridSize } from '@atlaskit/theme';

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${gridSize()}px;
  width: 100%;
  min-height: 70px;
`;

// Extend LoadingContainer with min-height to prevent content jumping when a user reaches
// the bottom of the InlineDialog and 'Branches/Tags/Commits' are loading.
export const SpinnerContainer = styled(LoadingContainer)`
  min-height: ${gridSize() * 4}px;
`;

// Override AK's button margin in order to left-align it (has "link" appearance)
export const RefButton = styled(Button)<any>`
  && {
    padding-left: 0;
    text-align: left;
  }

  & span {
    margin-left: 0;
  }
`;

export const RefList = styled.ul`
  list-style: none;
  padding-top: ${gridSize()}px;
  padding-left: 0;
`;

export const RefListItem = styled.li`
  margin-top: 0;

  a {
    display: block;
  }
`;

// Set min-height to 86px to align it with the height of the LoadingContainer (minHeight 60px + margin(top+bottom) 16px)
// to avoid modalDialog jumping when switching between LoadingContainer and ScrollableContents on the Branches/Tags empty state.
export const ScrollableContents = styled.div`
  min-height: 86px;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
`;
